import angular from 'angular';

(function() {
  'use strict';

  angular.module('app.principal').controller('OrderSectionCtrl', OrderSectionCtrl);

  OrderSectionCtrl.$inject = ['$uibModal', 'OrderParamSvc', 'AuthSvc'];

  function OrderSectionCtrl($uibModal, OrderParamSvc, AuthSvc) {
    var vm = this;

    // Data API
    vm.collapseTable = true;

    // Function API
    vm.addItem = addItem;
    vm.removeFn = removeFn;
    vm.isEditAuthorized = AuthSvc.isEditAuthorized();

    ////////////////////////

    vm.$onInit = function() {
      vm.collapseTable = vm.initClosed;
    };

    function addItem(typeSection) {
      $uibModal
        .open({
          component: 'ModalAddAttribute',
          resolve: {
            attributes: function() {
              return OrderParamSvc.filterDataModal(vm.fullAttributes, vm.orderAttributes, typeSection, vm.sections);
            },
            typeSection: function() {
              return typeSection;
            },
            // pour utliser la popup existant et opptimiez le code on devrait garder ses attributs
            nbAttribute: function() {
              return null;
            },
            filters: function() {
              return null;
            }
          }
        })
        .result.then(_closeModal, function() {});
    }

    function _closeModal(addedAttributes) {
      vm.addFn({ items: addedAttributes, section: vm.typeSection });
    }

    function removeFn(attribute) {
      vm.removeItemFn({ item: attribute });
    }
  }
})();
